import {useMemo} from "react";
import fetchData from "../api/fetch-suspense-wrapper/FetchSuspenseWrapper";
import useQueryCaller from "./useQueryCaller";

export default function useQueryCallerResource(query, params) {
    const queryCaller = useQueryCaller();

    return useMemo(() => {
        console.log("useQueryCallerResource", query, params);
        return fetchData(queryCaller(query, params));
    }, [query, params, queryCaller]);
}
